module.exports = __webpack_public_path__ + "img/case44.64c8bbc0.png";